// Components
import EventMediaCard from './EventMediaCard/EventMediaCard';
// Types
import { EventMediaItem } from './types';
// Styles
import styles from './StreamEventMedia.module.scss';

type StreamEventMediaProps = {
  media: EventMediaItem[];
};

const StreamEventMedia = ({
  media,
}: StreamEventMediaProps): JSX.Element | null => {
  if (media.length === 0) {
    return null;
  }

  return (
    <section
      className={styles.root}
      aria-labelledby="stream-event-media-heading"
    >
      <header className={styles.header}>
        <h2 id="stream-event-media-heading" className={styles.title}>
          Event Media
        </h2>
        <p className={styles.count}>{`${media.length} MEDIA`}</p>
      </header>

      <ol className={styles.grid}>
        {media.map((item) => (
          <li key={item.id} className={styles.gridItem}>
            <EventMediaCard item={item} />
          </li>
        ))}
      </ol>
    </section>
  );
};

export default StreamEventMedia;
